export enum ViewCategory {
  CustomData = 'Custom Data',
  EnterpriseData = 'Enterprise Data',
  ManagedData = 'Managed Data',
  Views = 'Views',
  Administration = 'Administration'
}
